import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const ChartCardSkeleton = () => (
  <Card className="flex h-full w-full flex-col overflow-hidden rounded-xl border-border/70 bg-card/95 shadow-sm p-0">
    <CardHeader className="space-y-2 border-b px-3 py-2.5">
      <Skeleton className="h-5 w-56" />
      <Skeleton className="h-3 w-80" />
    </CardHeader>
    <CardContent className="p-3">
      <Skeleton className="h-[320px] w-full" />
    </CardContent>
  </Card>
);

export default ChartCardSkeleton;
